import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(61, 220, 132, 0.4); }
  70%  { box-shadow: 0 0 0 6px rgba(61, 220, 132, 0); }
  100% { box-shadow: 0 0 0 0 rgba(61, 220, 132, 0); }
`;

export const Pulse = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(p) => p.theme.color.semantic.up};
  animation: ${pulse} 1.6s ${(p) => p.theme.ease} infinite;
`;
